import * as React from "react";

function cn(...classes: Array<string | false | null | undefined>) {
  return classes.filter(Boolean).join(" ");
}

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalidMessage?: string;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  (
    {
      className,
      invalidMessage,
      disabled,
      "aria-invalid": ariaInvalid,
      id,
      ...props
    },
    ref,
  ) => {
    const isInvalid =
      ariaInvalid === true || ariaInvalid === "true" || !!invalidMessage;

    const base = cn(
      "flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background",
      "placeholder:text-muted-foreground",
      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50 focus-visible:ring-offset-0",
      "disabled:cursor-not-allowed disabled:opacity-50",
      isInvalid &&
        "border-[hsl(var(--color-destructive))] focus-visible:ring-[hsl(var(--color-destructive))]/40",
      className,
    );

    return (
      <div className="flex w-full flex-col gap-1">
        <textarea
          className={base}
          ref={ref}
          id={id}
          disabled={disabled}
          aria-invalid={isInvalid || undefined}
          {...props}
        />
        {invalidMessage && (
          <span role="alert" className="text-xs text-red-600">
            {invalidMessage}
          </span>
        )}
      </div>
    );
  },
);
Textarea.displayName = "Textarea";

export { Textarea };
